import { useEffect, useMemo, useState } from "react";
import * as apiClienti from "../../../api/clienti";

export const useClientiOptions = ({ enabled, authToken }) => {
  const [clientiRaw, setClientiRaw] = useState([]);

  useEffect(() => {
    if (!enabled) return;
    if (!authToken) return;

    let cancelled = false;

    apiClienti.getAll(authToken).then((data) => {
      if (cancelled) return;
      setClientiRaw(Array.isArray(data) ? data : []);
    });

    return () => {
      cancelled = true;
    };
  }, [enabled, authToken]);

  const clientiOptions = useMemo(
    () =>
      clientiRaw.map((cliente) => ({
        ...cliente,
        value: cliente.id,
        label: cliente.fullname,
      })),
    [clientiRaw]
  );

  return { clientiOptions };
};
